import type { ICoreTimings } from "@pp/core/src/store/slices/config/types";

export const HighflyerCoreTimings: ICoreTimings = {
  bettingWindow: 5_000,
  bettingLastCall: 3_000,
  gameCommunicationDelay: 0,
  videoDelayBoundaryMin: 0,
  videoDelayBoundaryMax: 0,
  studioLatency: 0,
};
